<template>
  <div class="row">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'index-surveys'
  }
</script>



// WEBPACK FOOTER //
// src/pages/Surveys/Index.vue